import { render, staticRenderFns } from "./portfolio-large-grid.vue?vue&type=template&id=d035e2a2&scoped=true&lang=pug"
import script from "./portfolio-large-grid.vue?vue&type=script&lang=ts"
export * from "./portfolio-large-grid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d035e2a2",
  null
  
)

export default component.exports